<template>
    <div class="premium-settings-view flex-between-wrapper">
        <div class="premium-settings-view">
          <h3 class="view-title">Gain more control and focus for your students.</h3>
          <p class="view-description">Create a distraction-free experience for students by turning off ads. Enjoy more custom-settings like easily adjusting the minimum and maximum grade levels when using auto-assignments.</p>
          <div class="button-wrapper">
            <primary-button @click="handleClickPlan">Choose your plan</primary-button>
          </div>
        </div>
        <img class="feature-image" src="/assets/app/class/settings-frame-bg.png">
    </div>
</template>

<script>

import PrimaryButton from '../../common/PrimaryButton.vue';

export default {
  components: {
    PrimaryButton
  },
  methods: {
    handleClickPlan() {
      this.$emit('showPlan');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.premium-settings-view {
  .premium-settings-view {
    max-width: 375px;
    margin-right: 10px;
  }
  .feature-image {
    margin-top: -20px;
  }
  @media(max-width: 900px) {
    display: block;
    padding-top: 50px;
    .premium-settings-view {
      max-width: none;
      margin: 0;
    }
    .feature-image {
      margin-top: 20px;
    }
  }
}
</style>
